import React, { useContext } from 'react';
import { Navigate, Outlet, Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const ProtectedRoute: React.FC = () => {
  const { user, userType, approvalStatus, loading, signOut } = useContext(AuthContext);

  if (loading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        minHeight: '100vh', background: '#f9fafb',
      }}>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16,
        }}>
          <div style={{
            width: 40, height: 40,
            border: '3px solid #e5e7eb', borderTopColor: '#395ACB',
            borderRadius: '50%', animation: 'ds-spin 0.8s linear infinite',
          }} />
          <span style={{ fontSize: 14, color: '#6b7280', fontWeight: 500 }}>Loading...</span>
        </div>
        <style>{`@keyframes ds-spin { to { transform: rotate(360deg) } }`}</style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin users bypass approval check
  if (userType !== 'admin' && approvalStatus && approvalStatus !== 'approved') {
    const isPending = approvalStatus === 'pending';
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        minHeight: '100vh', background: '#f9fafb', padding: 20,
      }}>
        <div style={{
          maxWidth: 480, width: '100%', background: '#fff', borderRadius: 16,
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: 48, textAlign: 'center',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%', margin: '0 auto 20px',
            background: isPending ? '#eff6ff' : '#fef2f2',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="28" height="28" viewBox="0 0 20 20" fill={isPending ? '#395ACB' : '#dc2626'}>
              {isPending ? (
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              ) : (
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              )}
            </svg>
          </div>

          <h2 style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginBottom: 10 }}>
            {isPending ? 'Account Under Review' : 'Account Not Approved'}
          </h2>
          <p style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.7, marginBottom: 28 }}>
            {isPending
              ? 'Your account is currently being reviewed by our team. This typically takes less than 24 hours. You will receive an email once approved.'
              : 'Your account application was not approved. Please contact us for more information.'}
          </p>

          {!isPending && (
            <div style={{
              background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10,
              padding: 16, marginBottom: 24, fontSize: 14, color: '#374151',
            }}>
              Email: <a href="mailto:dispatch@speedyship.ca" style={{ color: '#395ACB', fontWeight: 600 }}>dispatch@speedyship.ca</a>
              <br />Phone: <strong>1-877-589-0573</strong>
            </div>
          )}

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button
              onClick={async () => { await signOut(); window.location.href = '/login'; }}
              style={{
                padding: '12px 28px', borderRadius: 50, border: 'none',
                background: '#395ACB', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer',
              }}
            >
              Sign Out
            </button>
            <Link to="/" style={{
              display: 'inline-flex', alignItems: 'center', padding: '12px 28px',
              borderRadius: 50, border: '1.5px solid #e5e7eb', background: '#fff',
              color: '#374151', fontSize: 15, fontWeight: 600, textDecoration: 'none',
            }}>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
